import extend from './extend/index'

const config = {
  auth: {
    //Register
    registerIsEnabled: false,
    //Login
    forgotPasswordIsEnabled: true
  },
  files: {
    staticServer: 'static.badpagroup.ir',
    prefixUrl: false, // set false to disable
    thumbServer: 'img.badpagroup.ir/unsafe', // set false to disable
    noImageUrl: '/img/base/no-image.svg',
    imagePlaceholderUrl: '/img/base/empty.svg',
    imageErrorUrl: '/img/base/image-error.svg',
    watermarkUrl: false // set false to disable
  },
  apiServer: 'api.badpagroup.ir',
  apiServerPrefix: 'v1',
  ssl: true,
  websiteUrl: 'badpagroup.ir',
  firebase: {
    config: {
      apiKey: 'AIzaSyBXh8ZUpPsSWsUHrS0faYXoRcN3vFbiWP8',
      authDomain: 'baarbaanet-3d3d3.firebaseapp.com',
      projectId: 'baarbaanet-3d3d3',
      storageBucket: 'baarbaanet-3d3d3.appspot.com',
      messagingSenderId: '1064221891381',
      appId: '1:1064221891381:web:872205b8515cd597038a7c',
      measurementId: 'G-VKV8CSV3FJ'
    },
    vapidKey:
      'BHojKQlR3PHP8KuE0oIJxI4QMpxHKO5sHIOHBwaJG4UFOfvnxNx-ly8kqgt_rzk3SPKhOpPwJzjKzAql3r4csOs'
  },
  sentry: {
    dsn: 'http://2a9de0089ef24893b483f8052fdf2d35@192.168.7.156:9000/11',
    tracePropagationTargets: ['192.168.7.175:9090']
  }
}

export default extend(config)
